import { useCallback } from 'react';

type Props = {
  className?: string;
};

export const ManageCookiePreferences = ({ className }: Props) => {
  const handleClick = useCallback(() => {
    window.Osano?.cm.showDrawer('osano-cm-dom-info-dialog-open');
  }, []);

  return (
    <button type="button" className={className} onClick={handleClick}>
      Manage Cookie Preferences
    </button>
  );
};
